export type DesktopPlatform = 'linux' | 'macos' | 'windows';
export type DownloadVerification = { manifestUrl: string; signatureUrl: string; publicKeyUrl: string; keyFingerprint: string };
export type DesktopRelease = {
  platform: DesktopPlatform;
  arch: 'x64' | 'arm64';
  format: 'AppImage' | 'deb' | 'rpm' | 'tar.gz' | 'dmg' | 'exe';
  version: string;
  url: string;
  sha256?: string;
  sizeBytes?: number;
  notes?: string;
  verification?: DownloadVerification;
};
export type NixDesktopSource = { version: string; sourceUrl: string; sha256: string; verification?: DownloadVerification };
export type DesktopDownloadsResponse = { schemaVersion: 1; releases: DesktopRelease[]; nix?: NixDesktopSource };

export async function fetchDesktopReleases(signal?: AbortSignal): Promise<DesktopDownloadsResponse> {
  const response = await fetch(apiUrl('/api/desktop/releases'), { signal, credentials: 'same-origin' });
  if (!response.ok) throw new Error(`Desktop releases request failed (${response.status})`);
  const body: unknown = await response.json();
  if (!body || typeof body !== 'object' || !Array.isArray((body as { releases?: unknown }).releases))
    throw new Error('Desktop releases response was invalid');
  return body as DesktopDownloadsResponse;
}
import { apiUrl } from '@/lib/shell';
